import { render, staticRenderFns } from "./StudentComplianceTranscriptEdit.vue?vue&type=template&id=0d44da3b&"
import script from "./StudentComplianceTranscriptEdit.vue?vue&type=script&lang=js&"
export * from "./StudentComplianceTranscriptEdit.vue?vue&type=script&lang=js&"
import style0 from "./StudentComplianceTranscriptEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports